<template>
  <div>
    <common-dialog
      ref="dialog"
      width="500px"
      title="查找"
      id-key="GoodsPriceId"
      :data="data"
      :line-form="true"
      form-label-width="85px"
      :form-rules="rules"
      :save-func="() => {}"
      @opened="onOpened"
      @edit-opened="onEditOpened"
      @closed="onClosed"
      saveButtonText="查 询"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-form-item label="存货编码">
          <el-input v-model="data.ProductNo" placeholder="请输入存货编码" />
        </el-form-item>
        <el-form-item label="存货名称">
          <el-input v-model="data.ProductName" placeholder="请输入存货名称" />
        </el-form-item>
      </template>
      <template #footer>
        <el-button type="primary" @click="toSave">保 存</el-button>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        ProductNo: "",
        ProductName: "",
      },
      isUpdate: false,
      formApi: require("@/api/sy/formSetting").default,
      api: require("@/api/sa/goodsPrice").default,
      // trendData: iForm.Data,
      showList: [],
      rules: {
        ProductNo: [{ required: true, message: "请输入分类编码" }],
        ProductName: [{ required: true, message: "请输入分类名称" }],
        Sn: [{ required: true, message: "请输入序号" }],
      },
    };
  },
  methods: {
    // 打开时获取显示显示列表
    onOpened() {},

    onEditOpened(data) {},
    toSave() {
      this.$refs.dialog.formValidate().then((valid) => {
        if (!valid) return;
        //移除 null 与 "" 的值
        var data = this.$commonJs.obj.removeNullKey(this.data);
        // this.$refs.dialog.isLoading = true;

        this.$parent.findList(data);
        // this.$emit("close-saved");
        this.close(true);
      });
    },
    onClosed() {
      this.showList = [];
    },
  },
};
</script>
